import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStopIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.2783 1C10.6761 1.00004 11.0576 1.15818 11.3389 1.43945L14.5605 4.66113C14.8418 4.9424 15 5.32391 15 5.72168V10.2783C15 10.6761 14.8418 11.0576 14.5605 11.3389L11.3389 14.5605C11.0576 14.8418 10.6761 15 10.2783 15H5.72168C5.32391 15 4.9424 14.8418 4.66113 14.5605L1.43945 11.3389C1.15818 11.0576 1.00004 10.6761 1 10.2783V5.72168C1.00004 5.32391 1.15818 4.9424 1.43945 4.66113L4.66113 1.43945C4.9424 1.15818 5.32391 1.00004 5.72168 1H10.2783ZM8 10C7.73478 10 7.48051 10.1054 7.29297 10.293C7.10543 10.4805 7 10.7348 7 11C7 11.2652 7.10543 11.5195 7.29297 11.707C7.48051 11.8946 7.73478 12 8 12C8.26522 12 8.51949 11.8946 8.70703 11.707C8.89457 11.5195 9 11.2652 9 11C9 10.7348 8.89457 10.4805 8.70703 10.293C8.51949 10.1054 8.26522 10 8 10ZM8 4C7.80109 4 7.61038 4.07907 7.46973 4.21973C7.32907 4.36038 7.25 4.55109 7.25 4.75V7.75C7.25 7.94891 7.32907 8.13962 7.46973 8.28027C7.61038 8.42093 7.80109 8.5 8 8.5C8.19891 8.5 8.38962 8.42093 8.53027 8.28027C8.67093 8.13962 8.75 7.94891 8.75 7.75V4.75C8.75 4.55109 8.67093 4.36038 8.53027 4.21973C8.38962 4.07907 8.19891 4 8 4Z",
		fill: "currentColor",
		stroke: "none"
	})
});
export default SvgStopIcon;
